export default "__VITE_ASSET__FN0aQjpV__ 100w";